
import React from 'react';
import TextInput from './TextInput';
import BooleanInput from './BooleanInput';
import NumberInput from './NumberInput';
import TimestampInput from './TimestampInput';
import FileInput from './FileInput';

const AnyInput = ({column, value, onChange}) => {

  switch(column.type) {
    case 'timestamp':
      return <TimestampInput key={column.name} column={column} value={value} onChange={onChange}/>;
    case 'boolean':
      return <BooleanInput key={column.name} column={column} value={value} onChange={onChange}/>;
    case 'number':
      return <NumberInput key={column.name} column={column} value={value} onChange={onChange}/>;
    case 'file':
      return <FileInput key={column.name} column={column} value={value} onChange={onChange}/>;
    default:
      return <TextInput key={column.name} column={column} value={value} onChange={onChange}/>;
  }
};

export default AnyInput;
